import { createContext, useContext } from 'react'

/**
 * Are omul Adam Intop? Vine din `/shell` (`adamAccess`, adica
 * `App\Ai\Assistant::reachable` - dreptul de pe capete SI macar o treapta de
 * gandire), si il pune `Shell` aici pentru paginile dinauntru.
 *
 * Implicit NU: cat nu s-a citit scheletul, sau cand serverul nu trimite
 * campul, nu se deseneaza nicio intrare spre Adam. Accesul il dam noi, pana
 * se bifeaza treapta in roluri nu-l are nimeni.
 */
export const AdamAccessContext = createContext<boolean>(false)

export function useAdamAccess(): boolean {
  return useContext(AdamAccessContext)
}
